module.exports = __webpack_public_path__ + "static/img/2-role.626de89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/2-role.png
// module id = usnH
// module chunks = 1